import {Component} from '@angular/core'
import {FormGroup, FormBuilder, Validators} from '@angular/forms'
import { NuclearObservable } from '../../nuclear-observable'
import { BaseComponent } from '../../components/base.component'
import { CustomerActions } from '../../actions/customer-actions'
import {Customer} from '../../types'
import {Router, ActivatedRoute} from '@angular/router'
import {customerGetters} from '../../stores/customer-store'

@Component({
  selector: 'client-name-page',
  template: `
    <split-view>
      <div left>
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12 mt-3">
              <div class="nc-section-icon fas fa-user-plus"></div>
              <h1 class="nc-section-header">
                What client(s) do you need content for?
              </h1>
              <p class="top-buffer">Your client's business and brand are unique. Tell our writers more so they can create content that fits your client's voice.</p>
            </div>
          </div>
        </div>
      </div>
      <div right>
        <div class="container-fluid big-top-buffer">
          <form [formGroup]="form" (ngSubmit)="onSubmit(form)">

            <div class="row">
              <div class="col-sm-12">
                <fieldset class="form-group">
                  <label for="business-name">Client's Name <span class="text-danger">*</span></label>
                  <input id="business-name" formControlName="businessName" type="text" class="form-control" placeholder="Ex. Boulder Flowers" autofocus autocomplete="off"/>
                  <div [hidden]="isWarningHidden(form.get('businessName'))" class="alert alert-danger">
                    Client name required
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <fieldset class="form-group">
                  <input type="submit" class="btn-lg hot-orange-button float-right" value="Submit & continue">
                </fieldset>
              </div>
            </div>
          </form>
        </div>
      </div>
    </split-view>
  `
})
export class ClientNamePage extends BaseComponent {
  form: FormGroup;
  private submitted: boolean = false;
  private saving: boolean = false;
  private customerId: number; // only if editing customer's business name
  customer: Customer;

  constructor(private formBuilder: FormBuilder,
              private customerActions: CustomerActions,
              private router: Router,
              private route: ActivatedRoute) {
    super()
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      businessName: [null, Validators.required]
    })
    const routeObs = this.route.params.subscribe(params => {
      this.clearRouteObservers()
      this.customerId = +params['customerId']
      if (this.customerId) {
        const custObs = NuclearObservable.from<Customer>(customerGetters.customer(this.customerId), { toJS: true }).subscribe(c => {
          this.customer = c
          if (this.customer) this.form.patchValue({businessName: this.customer.businessName})
        })
        this.observers.push(custObs)
      }
    })
    this.routeObservers.push(routeObs)
  }

  onSubmit(form: FormGroup): void {
    this.submitted = true
    if (!this.saving && form.valid) {
      this.saving = true

      // updating customer
      if (this.customer) {
        this.customerActions.updateCustomer(this.customer.id, form.value).then(() => {
          this.saving = false
          this.router.navigate(['../', 'about', 'industry'], {relativeTo: this.route})
        })
      } else {
        // creating a new customer
        let p = this.customerActions.createCustomer(form.value)
        p.then((newCustomer: Customer) => {
          this.saving = false
          this.router.navigate(['/account', 'signup', 'clients', 'setup', newCustomer.id, 'about', 'industry'])
        })
        .catch(() => {
          this.saving = false
        })
      }
    }
  }

  isWarningHidden(input: any): boolean {
    return input.valid || (input.pristine && !this.submitted) || (input.untouched && !this.submitted)
  }

}
